import * as React from "react";
import { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getListOfWordGroupsApi } from "../../../../../services/userSaveWordApi";

export default function EditWordGroupQuery(props) {
  // const { formProps, handleGroupWordSelected } = props;
  const { formProps, handleGroupWordSelected, defaults } = props;
  const [listOfGroups, setListOfGroups] = useState([]);
  // لیست گروه ها باید از بک گرفته شود
  const getListOfWordGroupsBack = async (data, paginateData = {}) => {
    let received = await getListOfWordGroupsApi({}, paginateData);
    if (received.data.success) {
      const list = received["data"]["data"]["docs"].map(
        (item) => item.nameOfgroup
      );
      setListOfGroups(list);
    } else {
      setListOfGroups(["مشکل در بارگزاری لیست گروه ها"]);
    }
  };

  useEffect(() => {
    getListOfWordGroupsBack();
  }, []);

  const selectedGroups = (Groups) => {
    handleGroupWordSelected(formProps, Groups);
  };

  return (
    <Autocomplete
      onChange={(event, value) => {
        selectedGroups(value);
      }}
      multiple
      limitTags={1}
      id="multiple-limit-tags"
      options={listOfGroups}
      getOptionLabel={(option) => option}
      defaultValue={defaults}
      renderInput={(params) => (
        <TextField {...params} label="انتخاب گروه ها" placeholder="گروه" />
      )}
    //   sx={{ width: "500px" }}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
